import { create } from 'zustand';

// For now, we need this to navigate to notes view from task view for agent work done.
export const useNavigationStore = create((set) => ({
    targetNoteId: null,
    setTargetNoteId: (id) => set({ targetNoteId: id }),
    clearTargetNoteId: () => set({ targetNoteId: null }),
}));
